define(["require", "exports", "./renderCustomValance"], function (require, exports, renderCustomValance_1) {
    "use strict";
    exports.__esModule = true;
    var simulationInterval = 2000;
    var availableStyles = [1, 2, 3, 4, 5, 6, 7, 8, 9, 11, 12, 13, 14];
    var autoPlay = true;
    var activeCanvasIndex = 0;
    var transitioning = false;
    var canvasIds = ["#coverSlotCanvas0", "#coverSlotCanvas1"];
    var slotMachineHistory = [];
    var curIndexInHistory = -1;
    var lastTransitionTime = null;
    var initialLoading = true;
    var selectedSettingIndex = -1;
    var currentSettingIndex = 0;
    var roomSettings = [
        { settingImageSrc: "Home-Windows-3.jpg", productType: renderCustomValance_1.ProductType.FullSet, curtainPositions: [{ x0: 180 + 18, x1: 680 - 18, y0: 105 + 20, y1: 570 - 8, width: 105, height: 100 }] },
        {
            settingImageSrc: "Home-Windows-6.jpg", productType: renderCustomValance_1.ProductType.ValanceOnly,
            curtainPositions: [{ x0: 310 + 12, x1: 610 - 12, y0: 150 + 16, y1: 500 - 6, width: 100, height: 100 },
                { x0: 0 + 12, x1: 310 - 12, y0: 150 + 16, y1: 500 - 6, width: 100, height: 100 },
                { x0: 610 + 12, x1: 910 - 12, y0: 150 + 16, y1: 500 - 6, width: 100, height: 100 }]
        },
        { settingImageSrc: "HomeWindow-1687.jpg", productType: renderCustomValance_1.ProductType.FullSet, curtainPositions: [{ x0: 480 * 0.8, x1: 850 * 0.8, y0: 205 * 0.8, y1: 675 * 0.8, width: 80, height: 102 }] },
        {
            settingImageSrc: "Home-Windows-Three-555.jpg", productType: renderCustomValance_1.ProductType.FullSet,
            curtainPositions: [{ x0: 103 * 0.8, x1: 373 * 0.8, y0: 120 * 0.8 * 1.153, y1: 620 * 0.8 * 1.153, width: 50, height: 96 },
                { x0: 450 * 0.8, x1: 720 * 0.8, y0: 120 * 0.8 * 1.153, y1: 620 * 0.8 * 1.153, width: 50, height: 96 },
                { x0: 820 * 0.8, x1: 1090 * 0.8, y0: 120 * 0.8 * 1.153, y1: 620 * 0.8 * 1.153, width: 50, height: 96 }]
        },
        { settingImageSrc: "Home-Windows-1.jpg", productType: renderCustomValance_1.ProductType.FullSet, curtainPositions: [{ x0: 70 + 18, x1: 875 - 18, y0: 10 + 20, y1: 500 - 8, width: 185, height: 105 }] },
    ];
    var simulationsPerSetting = 4;
    function setAutoPlay(set) {
        autoPlay = set;
        $('#coverSlotMachinePlay').text(autoPlay ? '\ue922' : '\ue923');
    }
    function isInViewPort(elem, marginPercent) {
        var elementTop = elem.offset().top + elem.outerHeight() * marginPercent / 100;
        var elementBottom = elem.offset().top + elem.outerHeight() - elem.outerHeight() * marginPercent / 100;
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();
        return elementBottom > viewportTop && elementTop < viewportBottom;
    }
    ;
    function getSettingIndexFromHistoryIndex(historyIndex) {
        if (selectedSettingIndex != -1) {
            return selectedSettingIndex;
        }
        return Math.floor(curIndexInHistory / simulationsPerSetting) % roomSettings.length;
    }
    function updateCanvasWithFabric(canvasIndex) {
        var _a = slotMachineHistory[curIndexInHistory], slotMachineStyleIndex = _a.slotMachineStyleIndex, slotMachineFabric = _a.slotMachineFabric, slotMachineFringe = _a.slotMachineFringe;
        var slotMachineRoomSettingIndex = getSettingIndexFromHistoryIndex(curIndexInHistory);
        var curtainPositions = roomSettings[slotMachineRoomSettingIndex].curtainPositions;
        var actions = $.Deferred();
        var result = actions;
        var _loop_1 = function () {
            var curtainPos = curtainPositions[i];
            var index = i;
            result = result.then(function () {
                return renderCustomValance_1.renderOverlayCanvas($(canvasIds[canvasIndex])[0], slotMachineFabric, slotMachineStyleIndex, roomSettings[slotMachineRoomSettingIndex].productType, { fringeColor: slotMachineFringe, hasFringe: 1, height: curtainPos.height, width: curtainPos.width }, curtainPos.x0, curtainPos.x1, curtainPos.y0, curtainPos.y1, index != 0);
            });
        };
        for (var i = 0; i < curtainPositions.length; i++) {
            _loop_1();
        }
        actions.resolve();
        return result;
    }
    ;
    function onCoverSlotMachine() {
        if (transitioning)
            return;
        transitioning = true;
        if (curIndexInHistory + 1 >= slotMachineHistory.length) {
            var slotMachineStyleIndex = availableStyles[Math.floor(Math.random() * availableStyles.length)];
            var fabricInfo = availableFabric[Math.floor(Math.random() * availableFabric.length)];
            var slotMachineFabric = renderCustomValance_1.getFabricNameFromCodeName(fabricInfo[0]);
            var slotMachineFabricId = fabricInfo[1];
            var slotMachineFabricGrade = fabricInfo[2];
            var slotMachineFringe = Math.floor(Math.random() * 11);
            curIndexInHistory = slotMachineHistory.length;
            slotMachineHistory.push({ slotMachineStyleIndex: slotMachineStyleIndex, slotMachineFabric: slotMachineFabric, slotMachineFabricId: slotMachineFabricId, slotMachineFabricGrade: slotMachineFabricGrade, slotMachineFringe: slotMachineFringe });
        }
        else {
            curIndexInHistory++;
        }
        switchToCurrentIndexInHistory();
    }
    function switchToCurrentIndexInHistory() {
        updateCanvasWithFabric(1 - activeCanvasIndex).then(function () {
            var newRoomSettingIndex = getSettingIndexFromHistoryIndex(curIndexInHistory);
            if (!initialLoading && (currentSettingIndex != newRoomSettingIndex)) {
                $('#coverSlotBackground').fadeOut(1000);
            }
            $(canvasIds[activeCanvasIndex]).fadeOut(initialLoading ? 10 : 1000, function () {
                activeCanvasIndex = 1 - activeCanvasIndex;
                if (currentSettingIndex != newRoomSettingIndex) {
                    $('#coverSlotBackground').attr('src', requestSpecificCdnEndpoint + 'idea-book-background/' + roomSettings[newRoomSettingIndex].settingImageSrc);
                }
                currentSettingIndex = newRoomSettingIndex;
                $('#coverSlotBackground').fadeIn(1000);
                $(canvasIds[activeCanvasIndex]).fadeIn(1000);
                lastTransitionTime = new Date();
                transitioning = false;
                initialLoading = false;
            });
        });
    }
    function onCoverSlotMachinePrev() {
        if (transitioning || (curIndexInHistory == 0))
            return;
        transitioning = true;
        curIndexInHistory--;
        switchToCurrentIndexInHistory();
    }
    var timerHandlers = [];
    function simulatorTimerHandler() {
        if (autoPlay && isInViewPort($('#coverSlotCanvas0'), 45) && (lastTransitionTime == null || ((new Date()).getTime() - lastTransitionTime.getTime()) > simulationInterval)) {
            onCoverSlotMachine();
        }
    }
    function onTimerSlotMachine() {
        for (var _i = 0, timerHandlers_1 = timerHandlers; _i < timerHandlers_1.length; _i++) {
            var handler = timerHandlers_1[_i];
            handler();
        }
    }
    function switchToFullCustomization() {
        setAutoPlay(false);
        var _a = slotMachineHistory[curIndexInHistory], slotMachineStyleIndex = _a.slotMachineStyleIndex, slotMachineFabric = _a.slotMachineFabric, slotMachineFabricId = _a.slotMachineFabricId, slotMachineFabricGrade = _a.slotMachineFabricGrade, slotMachineFringe = _a.slotMachineFringe;
        window.location.href = "/catalog/customize?cp=1&styleIndex=" + slotMachineStyleIndex + "&fc=" + slotMachineFabric + "&fi=" + slotMachineFabricId + "&fg=" + slotMachineFabricGrade + "&frg=" + slotMachineFringe;
    }
    function initializeAutoVideo(sel, videoUrl) {
        timerHandlers.push(function () {
            var $video = $(sel);
            if (!$video.data('srcSet')) {
                $video.data('srcSet', true);
                setTimeout(function () {
                    $video.attr('src', videoUrl);
                }, 500);
            }
            if (isInViewPort($video, 45)) {
                var video = $video[0];
                if (video.paused) {
                    video.play();
                }
            }
        });
    }
    exports.initializeAutoVideo = initializeAutoVideo;
    function initializeAutoSimulator() {
        $('#coverSlotMachinePrev').off('click').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            onCoverSlotMachinePrev();
            setAutoPlay(false);
        });
        $('#coverSlotMachineNext').off('click').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            onCoverSlotMachine();
            setAutoPlay(false);
        });
        $('#coverSlotMachinePlay').off('click').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            setAutoPlay(!autoPlay);
        });
        $('#coverSlotMachineCustomize, .auto-simulator-image-box').off('click').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            switchToFullCustomization();
        });
        $(canvasIds[1]).hide();
        $('#coverSlotBackground').attr('src', requestSpecificCdnEndpoint + 'idea-book-background/' + roomSettings[currentSettingIndex].settingImageSrc);
        var _loop_2 = function (i) {
            $(".scene-selector").append('<img id="scene-selection' + i + '" nohref src="' + requestSpecificCdnEndpoint + 'idea-book-background/' + roomSettings[i].settingImageSrc + '">');
            $("#scene-selection" + i).click(function (evt) {
                evt.preventDefault();
                evt.stopPropagation();
                if (selectedSettingIndex != i) {
                    selectedSettingIndex = i;
                    if (!transitioning) {
                        switchToCurrentIndexInHistory();
                    }
                }
                return false;
            });
        };
        for (var i = 0; i < roomSettings.length; i++) {
            _loop_2(i);
        }
        onCoverSlotMachine();
        timerHandlers.push(simulatorTimerHandler);
        setInterval(onTimerSlotMachine, 500);
    }
    exports.initializeAutoSimulator = initializeAutoSimulator;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/autoSimulator.js
// module id = 81
// module chunks = 0